// /documents — real route (design doc's G2). Thin-server-shell parity: the
// original (app/documents/page.tsx:11-17) is just
// `auth() -> redirect('/sign-in?...') -> <DocumentsClient/>`; the
// redirect-if-signed-out half is now the `_authed` guard (routes/guards.tsx).
// Unlike library/skills, DocumentsClient doesn't call useDocumentTitle
// itself (its title came from Next's static `metadata` export,
// app/documents/page.tsx:6-9) — set it here to preserve the tab title.
// Registered into the route tree from routes/agents.tsx.
import { createRoute } from '@tanstack/react-router';
import { DocumentsClient } from '@/app/documents/client';
import { useDocumentTitle } from '@/lib/use-document-title';
import { authedRoute } from './guards';

function DocumentsRoute() {
  useDocumentTitle('Documents');
  return <DocumentsClient />;
}

export const documentsRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/documents',
  component: DocumentsRoute,
});
